import React from 'react';
import { Lead } from '@tassomutuo-backoffice/types';
import { Box, Typography } from '@mui/material';
import LabelValueItem from './LabelValueItem';

interface IProps {
  lead: Lead;
}
const LeadDetailsPersonalInfoBox = ({ lead }: IProps) => {
  const leadProperties = lead.properties;
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        bgcolor: 'white',
        m: 2,
        p: 2,
        minWidth: '300px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap-reverse',
            gap: 2,
            borderBottom: (th) => `1px solid ${th.palette.divider}`,
            width: '100%',
            pb: 1,
          }}
        >
          <Typography
            fontWeight="bold"
            textTransform="uppercase"
            sx={{ color: (th) => th.palette.secondary.dark }}
          >
            INFORMAZIONI PERSONALI
          </Typography>
        </Box>

        <Box pt={1}>
          {leadProperties?.quality && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Qualità"
              value={leadProperties?.quality}
            />
          )}
          {leadProperties?.job && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Impiego"
              value={leadProperties?.job}
            />
          )}
          {leadProperties?.age && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Età"
              value={leadProperties?.age}
            />
          )}
          {leadProperties?.dettagli_eta && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Dettagli età"
              value={leadProperties?.dettagli_eta}
            />
          )}
          {leadProperties?.commitments && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Impegni"
              value={leadProperties?.commitments}
            />
          )}
          {leadProperties?.income && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Reddito"
              value={leadProperties?.income}
            />
          )}
          {leadProperties?.savings && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Risparmi"
              value={leadProperties?.savings}
            />
          )}
          {leadProperties?.additional_guarantees && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Ulteriori garanti"
              value={leadProperties?.additional_guarantees}
            />
          )}
          {leadProperties?.azienda_in_cui_lavora && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Azienda in cui lavora"
              value={leadProperties?.azienda_in_cui_lavora}
            />
          )}
          {leadProperties?.anzianita_lavorativa && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Anzianità lavorativa"
              value={leadProperties?.anzianita_lavorativa}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeadDetailsPersonalInfoBox;
